import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import enUS from './lang/en'
import zhCN from './lang/cn'
import { getLanguage } from '@/utils/utils';
const language = getLanguage()
const initLocale = {
  en: 'en-US',
  zh: 'zh-CN'
}
const resources = {
  "en-US": enUS,
  "zh-CN": zhCN
}
// console.log(initLocale[language])
i18n.use(initReactI18next).init({
  resources,
  lng: initLocale[language],
  interpolation: {
    escapeValue: false
  }
})
console.log(i18n)
export default i18n